import { render, staticRenderFns } from "./AdminAddIframe.vue?vue&type=template&id=ef858dd2&"
import script from "./AdminAddIframe.vue?vue&type=script&lang=ts&"
export * from "./AdminAddIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports